module.exports = {
	"articleTitle1": "City announces locations for deer cull ",
	"catImage": "orangestar.png",
	"totalCats": 1,
	"name": "Bandemer Park",
	"articleLink2": "https://www.michigandaily.com/section/news/city-council-discusses-south-pond-village-access-deer-management-thursday-meeting",
	"articleSnippet1": "Dec 15, 2015 ... Sharpshooters will kill 100 deer and remove them from the following parks: Arbor \nHills Nature Area, Argo Nature Area, Bandemer Nature Area, ...",
	"articleSnippet2": "Aug 12, 2015 ... The council also voted unanimously in support of paying Saladino Construction \nCompany to provide barrier-free access to the Bandemer Park ...",
	"totalMisc": 0,
	"articleTitle2": "City Council discusses South Pond Village access, deer ...",
	"address": "1352 Lakeshore Drive, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.295524,
		"lng": -83.745309
	},
	"tips": [
		{
			"text": "This place is a hidden gem. There is a long dock here that is absolutely perfect for sunbathing.",
			"person": "Erik Forkin"
		}
	],
	"articleLink1": "https://www.michigandaily.com/section/news/deer-cull-will-close-26-ann-arbor-parks-after-4-pm-starting-january",
	"categories": {
		"sunbathingspot": 1,
		"location": 1,
		"recarea": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/bandemerpark.json
// module id = 820
// module chunks = 0